import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=7ed6cd48&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=js&"
export * from "./MyOrders.vue?vue&type=script&lang=js&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=7ed6cd48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6cd48",
  null
  
)

export default component.exports